import { twMerge } from 'tailwind-merge';
import { Box, InputLabel, Typography } from '@mui/material';

import { FieldArrayFormField } from 'types';
import { QuestionLabel } from 'components/question-label';
import { defaultLanguage, useCourseContext } from 'context';
import { getTranslatedQuestionLabel } from 'utils/question-label';

import { DynamicFormFields } from '.';

export const FieldArrayField = ({
  label,
  formId,
  options,
}: FieldArrayFormField & { formId: string }) => {
  const { language } = useCourseContext();
  const isHorizontal = options?.layout === 'horizontal';
  return (
    <Box>
      {label && (
        <InputLabel component="div">
          <QuestionLabel value={label} />
        </InputLabel>
      )}
      {options && (
        <>
          <Box
            className={twMerge(
              'flex',
              !isHorizontal && 'flex-col',
              isHorizontal && 'flex-wrap'
            )}
          >
            <DynamicFormFields
              hideLabels
              formId={formId}
              fields={options.fields}
              container={(field, node, index) => {
                const label = getTranslatedQuestionLabel(
                  field,
                  language,
                  defaultLanguage
                );
                return (
                  <Box
                    key={field.id}
                    className={twMerge(
                      'flex w-full flex-1 gap-2',
                      !isHorizontal && 'flex-col',
                      isHorizontal && 'max-w-1/2 basis-1/2',
                      index > (isHorizontal ? 1 : 0) && 'mt-2'
                    )}
                  >
                    {!isHorizontal && (
                      <Typography component="div" className="w-full">
                        <QuestionLabel value={label} />
                      </Typography>
                    )}
                    <Box
                      className={
                        isHorizontal ? 'flex-1' : 'w-full [&>div]:w-full'
                      }
                    >
                      {node}
                    </Box>
                    {isHorizontal && (
                      <Box className="flex-1">
                        <Typography component="div" className="mt-3">
                          <QuestionLabel value={label} />
                        </Typography>
                      </Box>
                    )}
                  </Box>
                );
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
